// @flow
import { styled } from 'mz-ui-kit';

export const Container = styled('div', {
  marginTop: '20px',
});

export const ButtonWrapper = styled('div', {
  marginTop: '10px',
});

export const CouponCodeWrapper = styled('div', {
  marginBottom: '10px',
});
